import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import EditBlogForm from '../Components/Blogs/EditBlogForm'
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import { db, storage } from '../firebase.config'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
import {useParams,useNavigate} from "react-router-dom"
const EditBlog = () => {
    const {id} = useParams()
    const navigate = useNavigate()
    const [blogTitle, setBlogTitle] = useState("")
    const [blogContent, setBlogContent] = useState("")
    const [coverImage, setCoverImage] = useState("")
    const [bannerImage, setBannerImage] = useState("")
    const [blogWriter, setBlogWriter] = useState("")
    const [blogContentTwo, setBlogContentTwo] = useState("")
    const [blogImageOne, setBlogImageOne] = useState("")
    const [blogImageTwo, setBlogImageTwo] = useState("")
    const addCoverImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setCoverImage(downloadURL)
         console.log(downloadURL)
       });
     }
   );
    }
    const addBannerImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBannerImage(downloadURL)
         
       });
     }
   );
    }
    const addImageOne = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBlogImageOne(downloadURL)
         
       });
     }
   );
    }
    const addImageTwo = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBlogImageTwo(downloadURL)
         
       });
     }
   );
    }
    const addBlog = () =>{
        const docRef = doc(db, "blogs",id);
        updateDoc(docRef,{
            name: blogTitle,
            contentOne:blogContent,
            imageOne: blogImageOne,
            imageTwo:blogImageTwo,
            contentTwo:blogContentTwo,
            coverImage:coverImage,
            bannerImage:bannerImage

    })
  
   navigate("/blogs")
    }
    const fetchEvents = async () =>{
        const docRef = doc(db, "blogs", id);
const docSnap = await getDoc(docRef);
      
if (docSnap.exists()) {
  console.log("Document data:", docSnap.data());
  const data = docSnap.data()
 setBlogTitle(data?.name)
 setBlogContent(data?.contentOne)
 setBlogContentTwo(data?.contentTwo)
 setBlogImageOne(data?.imageOne)
 setBlogImageTwo(data?.imageTwo)
 setCoverImage(data?.coverImage)
 setBannerImage(data?.bannerImage)
} else {
  // docSnap.data() will be undefined in this case
  console.log("No such document!");
}
    }
    useEffect(() => {
     fetchEvents()
    
      
    }, [])
  return (
    <div>
        <MultiLevelSidebar />
        <EditBlogForm blogTitle={blogTitle} setBlogTitle={setBlogTitle}
     blogContent={blogContent} setBlogContent={setBlogContent}
      coverImage={coverImage} setCoverImage={setCoverImage}
    bannerImage={bannerImage} setBannerImage={setBannerImage}
    blogWriter={blogWriter} setBlogWriter={setBlogWriter}
    blogContentTwo={blogContentTwo} setBlogContentTwo={setBlogContentTwo}
    blogImageOne={blogImageOne} setBlogImageOne={setBlogImageOne}
    setBlogImageTwo={setBlogImageTwo} blogImageTwo={blogImageTwo}
    addCoverImage={addCoverImage} addBannerImage={addBannerImage}
    addImageOne={addImageOne}  addImageTwo={addImageTwo}
    addBlog={addBlog} />
    </div>
  )
}

export default EditBlog